const Footer = () => (
  <footer className="text-center py-6 bg-neutral-light text-neutral-dark font-body mt-10">
    &copy; {new Date().getFullYear()} Sophie Zhou. All rights reserved.
  </footer>
);
export default Footer;
